import { deleteConversationsFromTable } from './deleteConversations';
import { deleteItemsFromTable } from './deleteItems';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { ActionSource, logUsage } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getInboxClassificationFilterForTable } from 'owa-mail-list-store';

/**
 * Method removes given rows from the given tableView
 * @param rowKeys - rowKeys of the tableView to be removed from
 * @param originalTableViewId - source tableView id
 * @param isExplicitSoftDelete - flag for explicite soft delete
 * @param actionSource - source of the action
 */
export default function deleteMailListRows(
    rowKeys: string[],
    originalTableViewId: string,
    isExplicitSoftDelete: boolean,
    actionSource?: ActionSource
) {
    const tableView = listViewStore.tableViews.get(originalTableViewId);
    const instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);

    if (isInboxPlusEnabled() && folderNameToId('inbox') === tableView.tableQuery.folderId) {
        logUsage('InboxPlusDelete', [getInboxClassificationFilterForTable(originalTableViewId)], {
            isCore: true,
        });
    }

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            deleteConversationsFromTable(
                rowKeys,
                originalTableViewId,
                isExplicitSoftDelete,
                instrumentationContexts,
                actionSource
            );
            break;

        case ReactListViewType.Message:
            deleteItemsFromTable(
                rowKeys,
                originalTableViewId,
                isExplicitSoftDelete,
                instrumentationContexts,
                actionSource
            );
            break;
    }
}
